import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './lib/AuthContext'
import './index.css'

import DirectoryPage      from './pages/DirectoryPage'
import SubmitPage         from './pages/SubmitPage'
import VotePage           from './pages/VotePage'
import BlogPage           from './pages/BlogPage'
import AdminPage          from './pages/AdminPage'
import ResetPasswordPage  from './pages/ResetPasswordPage'
import MyListingsPage     from './pages/MyListingsPage'
import GlobePage          from './pages/GlobePage'
import SupportPage        from './pages/SupportPage'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"          element={<DirectoryPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/submit"    element={<SubmitPage />} />
          <Route path="/vote"      element={<VotePage />} />
          <Route path="/blog"      element={<BlogPage />} />
          <Route path="/news"      element={<BlogPage />} />
          <Route path="/globe"          element={<GlobePage />} />
          <Route path="/support"        element={<SupportPage />} />
          <Route path="/my-listings"    element={<MyListingsPage />} />
          <Route path="/admin"          element={<AdminPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*"              element={<DirectoryPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
